export const VideoExtensions = [
    ".ogg", ".mp4", ".mov", ".webm", ".avi", ".wmv", ".flv", ".avchd", ".mkv"
];